import { useRef, useState, useEffect, useCallback } from 'react';

import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';

import Iconify from '../Iconify';
import { useDispatch, useSelector } from '../../redux/store';
import { sendMessage } from '../../redux/slices/aiConversation';
// ----------------------------------------------------------------------

export function ChatMessageInput() {
  const fileRef = useRef(null);
  const dispatch = useDispatch();
  const { isLoading, selectedId, inputKey } = useSelector((state) => state.aiConversation);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMessage('');
  }, [selectedId, inputKey]);

  const handleChangeMessage = useCallback((event) => {
    setMessage(event.target.value);
  }, []);

  const handleSendMessage = useCallback(async () => {
    const trimmedMessage = message.trim();
    if (!trimmedMessage || isLoading) return;

    setMessage('');

    try {
      const messageParams = {
        selectedId,
        message: {
          id: Date.now(),
          sender_id: '1',
          body: trimmedMessage,
          created_at: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        }
      };

      await dispatch(sendMessage(messageParams));
    } catch (error) {
      console.error(error);
    }
  }, [message, selectedId, isLoading, dispatch]);

  const handleOnEnterKey = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <>
      <InputBase
        multiline
        minRows={1}
        maxRows={4}
        name="chat-message"
        id="chat-message-input"
        value={message}
        onKeyDown={handleOnEnterKey}
        onChange={handleChangeMessage}
        placeholder="Posez une question... (Entrée pour envoyer, Maj+Entrée pour saut de ligne)"
        disabled={isLoading}
        startAdornment={
          <IconButton disabled={isLoading} sx={{ mr: 0.5 }}>
            <Iconify icon="eva:message-circle-outline" />
          </IconButton>
        }
        endAdornment={
          <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={handleSendMessage} disabled={isLoading || !message.trim()} color="primary">
              <Iconify icon="eva:paper-plane-outline" />
            </IconButton>
          </Box>
        }
        sx={[
          (theme) => ({
            px: 1.5,
            py: 1,
            minHeight: 56,
            maxHeight: 140,
            flexShrink: 0,
            borderTop: `solid 1px ${theme.palette.divider}`,
            alignItems: 'center'
          })
        ]}
      />

      <input type="file" ref={fileRef} style={{ display: 'none' }} />
    </>
  );
}
